import { useState } from "react";
import { TextField } from "@mui/material";

import Dialog from "../../components/Dialog";
import { useLostPassword } from "../../api/authenticationApi";
import type { Role } from "../../types/user";

export const LostPasswordDialog = ({
  role,
  close,
}: {
  role: Role;
  close: () => void;
}) => {
  const { mutateAsync: lostPassword } = useLostPassword({ role });
  const [id, setId] = useState("");
  const [email, setEmail] = useState("");
  const [userCode, setUserCode] = useState("");

  return (
    <Dialog
      title="비밀번호 분실"
      buttons={["ok", "close"]}
      ok={async () => {
        try {
          await lostPassword({ email, id, user_code: userCode });
          alert(
            `임시 비밀번호가 ${email}로 발급되었습니다.\n메일이 오지 않는다면 스팸메일함을 확인해 주세요.`
          );
        } catch (e) {
          alert("입력한 정보와 일치하는 계정이 없습니다.");
        }
        close();
      }}
      close={close}
    >
      <div className="vertical center gap-normal" style={{ width: "100%" }}>
        <TextField
          label="아이디"
          variant="standard"
          value={id}
          fullWidth
          onChange={(e) => setId(e.target.value)}
        />
        {role === "student" && (
          <TextField
            label="연수번호"
            placeholder="ex. x07800x-0xxx"
            variant="standard"
            value={userCode}
            fullWidth
            onChange={(e) => setUserCode(e.target.value)}
          />
        )}
        <TextField
          label="이메일"
          variant="standard"
          value={email}
          fullWidth
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
    </Dialog>
  );
};
